import { Injectable } from '@angular/core';
import { RCSRepliesModel } from './rcs-replies-model';

@Injectable({
  providedIn: 'root'
})

export class RCSRepliesModelAdapter {
  adapt(item: any): RCSRepliesModel {
    return new RCSRepliesModel(item);
  }

  adaptArray(init: Array<any>): RCSRepliesModel[] {
    if (init && init.length > 0) {
      return init.length > 1
      ? init.map(table => new RCSRepliesModel(table))
      : [new RCSRepliesModel(init[0])];
    } else {
      return [];
    }
  }

  createEmpty() {
    return new RCSRepliesModel({
      RCSReplyID: 0,
      ReplyDate: '',
      RCSMessageBody: '',
      Number: '',
    });
  }
}
